import classNames from 'classnames'

export default function Input(props) {
  let { className, type, title, ...rest } = props
  return (
    <div className='border border-neutral-800 rounded-xl flex flex-col text-white relative'>
      <label className='absolute text-xs -top-2 left-3 bg-background px-1'>{title}</label>
      {type === 'textarea' ?
        <textarea
          className={classNames(className, 'bg-transparent w-full font-bold text-white border-none outline-none p-4')}
          {...rest}
        /> :
        <input
          type={type}
          className={classNames(className, 'bg-transparent w-full font-bold text-white border-none outline-none p-4')}
          {...rest}
        />
      }
    </div>
  )
}

